<script lang="ts">
	export let title: string;
</script>

<div
	class="flex justify-center items-center gap-3 text-fx-grey-300 font-semibold text-center rounded-xl squircle-xl bg-fx-grey-600 py-3 sm:py-4 cursor-not-allowed text-xs sm:text-sm w-full"
>
	<svg
		class="animate-spin h-4 w-4"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
	>
		<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
		<path
			class="opacity-75"
			fill="currentColor"
			d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
		/>
	</svg>
	<span>{title}</span>
</div>
